import { urlConfig } from "../../config/urlConfig";
import { postCall, postFileDownloadCall } from "../httpService";
import { PreworksummaryModelDetails } from "../../types/PreworksummaryModel";
import { GetExceptionsDetails } from "../../types/DocDistroCustomExceptionModel";
import { DownstreamreprocessModel } from "../../types/DownstreamreprocessModel";
import { ARFDocument } from "../../types/ARFDocumentModel";

const baseUrl = process.env.REACT_APP_API_URL;
const downstreamSummaryGetDataUrl = urlConfig.DownStreamLoadGrid;
const downFileUrl = urlConfig.Searchfiledownload;
const getExceptionsDetailsUrl = urlConfig.ExceptionDetails;
const getEmailDocumentListUrl = urlConfig.GetEmailDocument;
const getARFDocumentUrl = urlConfig.GetARFDocument;

export const getDownstreamSummaryData = async (
  params: PreworksummaryModelDetails
) => {
  try {
    const response = await postCall(downstreamSummaryGetDataUrl, params);
    return response.data;
  } catch (error) {
    console.error("Error in Downstream summary data fetching ", error);
    throw error;
  }
};

export const downloadFile = async (params: any) => {
  try {
    const response = await postFileDownloadCall(downFileUrl, params);
    return response;
  } catch (error) {
    console.error("Error in Downstream summary downloadFile", error);
    throw error;
  }
};

export const GetExceptionDetails = async (params: GetExceptionsDetails) => {
  try {
    const response = await postCall(getExceptionsDetailsUrl, params);
    return response.data;
  } catch (error) {
    console.error("Error in Exception Details fetching", error);
    throw error;
  }
};

export const GetEmailDocumentList = async (
  params: DownstreamreprocessModel[]
) => {
  try {
    const response = await postCall(getEmailDocumentListUrl, params);
    return response.data;
  } catch (error) {
    console.error("Error in Email Document List fetching", error);
    throw error;
  }
};

export const GetEmailDocument = async (params: any) => {
  try {
    const response = await postCall(urlConfig.EmailDocument, params);
    return response.data;
  } catch (error) {
    console.error("Error in Email Document fetching", error);
    throw error;
  }
};

export const GetARFDocuments = async (params: ARFDocument[]) => {
  try {
    const response = await postCall(getARFDocumentUrl, params);
    return response.data;
  } catch (error) {
    console.error("Error in Get ARF Document", error);
  }
};

export const ReprocessSubSystem = async (
  params: DownstreamreprocessModel[]
) => {
  try {
    const response = await postCall(urlConfig.ReprocessSubSystem, params);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error in Reprocess Sub System", error);
    throw error;
  }
};

export const ReprocessDownStream = async (
  params: DownstreamreprocessModel[]
) => {
  try {
    const response = await postCall(urlConfig.ReprocessDownstreamFD, params);
    return response.data;
  } catch (error) {
    console.error("Error in Reprocess DownStream FD", error);
    throw error;
  }
};

export const ReprocessEdelivery = async (
  params: DownstreamreprocessModel[]
) => {
  try {
    const response = await postCall(urlConfig.ReprocessEdelivery, params);
    return response.data;
  } catch (error) {
    console.error("Error in Reprocess Edelivery", error);
    throw error;
  }
};
